import React from 'react';
import { MessageCircle } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useWhatsAppModal } from '@/contexts/WhatsAppModalContext';
import { cn } from '@/lib/utils';

interface WhatsAppButtonProps {
  text?: string;
  source: string;
  variant?: 'default' | 'whatsapp' | 'outline' | 'secondary' | 'ghost' | 'link' | 'destructive';
  size?: 'default' | 'sm' | 'lg' | 'icon';
  className?: string;
  showIcon?: boolean;
  fullWidth?: boolean;
  customMessage?: string;
}

const WhatsAppButton: React.FC<WhatsAppButtonProps> = ({
  text = 'Falar com especialista',
  source,
  variant = 'default',
  size = 'lg',
  className,
  showIcon = true,
  fullWidth = false,
  customMessage,
}) => {
  const { openWhatsAppModal } = useWhatsAppModal();

  return (
    <Button
      variant={variant}
      size={size}
      onClick={() => openWhatsAppModal(source, customMessage)}
      className={cn('inline-flex items-center justify-center gap-2', fullWidth && 'w-full', className)}
    >
      {showIcon && <MessageCircle className="h-5 w-5 shrink-0" aria-hidden="true" />}
      <span className="leading-none">{text}</span>
    </Button>
  );
};

export default WhatsAppButton;
